import { AccommodationStock, AccommodationStockListFilter, AccommodationStockRoom } from "../objects/accommodationStockList";

export const filterAccommodationList = (accommodation_stocks: AccommodationStock[], filter: AccommodationStockListFilter): AccommodationStock[] => {
    const results: AccommodationStock[] = [];
    accommodation_stocks.forEach(accommodation_stock => {
        if(filter.hide_hotels_without_stock) {
            const rooms: AccommodationStockRoom[] = []
            accommodation_stock.rooms.forEach(room => {
                if(Object.values(room.client_stocks).length > 0 && Object.values(room.client_stocks).some(stock => (!!stock.quantity))) {
                    rooms.push(room);
                }
            });
            if(rooms.length > 0) {
                results.push({...accommodation_stock, rooms});
            }
        } else {
            results.push(accommodation_stock);
        }
    });

    return results;
}